import { HttpClient } from "@/shared";
import { Amendment } from "../../application/domain/amendment";
import { IAmendmentRepository } from "../../application/ports/outbound/IAmendmentRepository";
import { AmendmentResponseDto } from "../dto/amendment-response.dto";
import { AmendmentMapper } from "../mapper/response-entity.mapper";

export class ApiAmendmentRepo implements IAmendmentRepository {
    constructor(
        private readonly httpClient : HttpClient
    ) {
        
    }
    async fetchAmendmentHistory(i9FormId: string): Promise<Array<Amendment>> {
        const amendMentHistoryDto = await this.httpClient.get<Array<AmendmentResponseDto>>(`/amendment/${i9FormId}`);
        return amendMentHistoryDto.data?.length > 0 ? amendMentHistoryDto.data.map(AmendmentMapper.toEntity) : [];
    }
}